import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quoteOfferPriceDiscounted',
  standalone: true,
})
export class QuoteOfferPriceDiscountedPipe implements PipeTransform {
  transform(paymentValue?: number, discountPercentage = 1): number {
    if (paymentValue == null) return 0;
    return Math.ceil(paymentValue * discountPercentage * 100) / 100;
  }
}
